export default "<div #map id=\"map\">\r\n\r\n</div>";